import { createTheme } from "@mui/material/styles";

const BRAND_BLUE = "#0069a7";
const BRAND_CYAN = "#06b6d4";
const FONT_FAMILY = '"Montserrat", sans-serif';

export const publicTheme = createTheme({
  palette: {
    primary: {
      main: BRAND_BLUE,
      dark: "#004d7f",
      light: "#e6f7ff",
    },
    secondary: {
      main: BRAND_CYAN,
      dark: "#0891b2",
      light: "#cffafe",
    },
    background: {
      default: "#ffffff",
      paper: "#f8fafc",
    },
    text: {
      primary: "#1e293b",
      secondary: "#64748b",
    },
    divider: "#e2e8f0",
  },
  typography: {
    fontFamily: FONT_FAMILY,
    h1: { fontWeight: 800 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    button: {
      fontWeight: 600,
      textTransform: "none",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    // Ensures ALL MUI Typography inherits the theme font automatically
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
      },
    },
    // Ensures MUI Buttons also inherit the font
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
      },
    },
  },
});
